import React from 'react'
import { useOutletContext } from 'react-router-dom'
import { OutletContext } from './employer-settings-wrapper'
import { useTerminalsQuery } from '../../queries/terminals'
import TerminalsList from '../../components/terminals/list'
import SidebarContentTitle from '../../components/layout/sidebar/sidebar-content-title'
import { Box } from 'react-bulma-components'
import { compareDocsById } from '../../utils/documents'
import TerminalExplanation from '../../components/terminals/terminal-explanation'

const TerminalsSettings: React.FC = () => {
  const { employer } = useOutletContext<OutletContext>()
  const { data: terminals } = useTerminalsQuery(
    { 'usagePeriods.employer': employer._id },
    {
      enabled: Boolean(employer),
    },
  )

  //TODO: handle that in the backend and remove this filter
  const terminalsForEmployer = terminals?.map(terminal => {
    terminal.usagePeriods = terminal.usagePeriods.filter(usagePeriod =>
      compareDocsById(usagePeriod.employer, employer),
    )
    return terminal
  })

  return (
    <>
      <SidebarContentTitle
        title="Bornes de Pointage"
        help={<TerminalExplanation textColor={'white'} />}
      />
      <Box>
        <TerminalsList data={terminalsForEmployer || []} />
      </Box>
    </>
  )
}

export default TerminalsSettings
